import React from 'react';
import { NotesEntityFields } from 'common/graphql/__generated__/NotesEntityFields';
import {
  NoteTravelerCreate,
  NoteTravelerCreateVariables,
} from './__generated__/NoteUserProfileCreate';
import { NotesSectionProps } from 'common/components/NotesSection';
import { GenericNotesSection } from 'common/components/ActionMenu/Notes';

import NOTE_USER_SETUP_CREATE from './NoteUserProfileCreate.graphql';

type NotesProps = Pick<NotesSectionProps, 'listRefreshRequest'> & {
  id: string;
  data: NotesEntityFields[];
  loading?: boolean;
};

export const Notes: React.FC<NotesProps> = ({
  id,
  data,
  loading,
  listRefreshRequest,
}) => {
  return (
    <GenericNotesSection<
      any,
      NoteTravelerCreate, // TMutationResult
      NoteTravelerCreateVariables // TMutationVariables
    >
      entityId={id}
      data={data}
      loading={loading}
      mutationDocument={NOTE_USER_SETUP_CREATE}
      listRefreshRequest={listRefreshRequest}
    />
  );
};
